import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ApproveAccountIntegrationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ApproveAccountIntegrationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const approveAccountIntegration = (request: ApproveAccountIntegrationRequest, options?: CashRequestOptions) =>
  post<ApproveAccountIntegrationRequest, ApproveAccountIntegrationResponse>(
    '/2.0/cash/approve-account-integration',
    request,
    { ...options, rejectOnError: true }
  )
